import { Fragment } from 'react'

import { m } from 'framer-motion'
import Image from 'next/image'

import CocOnboardingImageScreen4 from '@/assets/images/clashofclans/onboarding-image-screen-4.webp'

import { variants } from '../../../constants'

import styles from './styles.module.scss'

export const Screen4 = () => (
  <Fragment>
    <m.h1
      key="coc-screen-4-title"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.4, ease: 'easeInOut' }}
      className={styles.Title}
    >
      Earn Points and Bonuses
    </m.h1>
    <m.p
      key="coc-screen-4-subtitle"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.3, ease: 'easeInOut' }}
      className={styles.Subtitle}
    >
      Every purchase you make in the Clash of Clans Store earns you points towards your next Store Bonus.
    </m.p>
    <m.div
      key="coc-screen-4-image"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
      className={styles.ItemArea}
    >
      <div className={styles.ItemImage}>
        <Image src={CocOnboardingImageScreen4} alt="" width={240} />
      </div>
    </m.div>
    <m.div
      key="coc-screen-4-footer"
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
      className={styles.BottomText}
    >
      <p>
        Want extra points? Complete the challenges listed in the Bonus Track. Each season there is a new track of
        bonuses to earn.
      </p>
    </m.div>
  </Fragment>
)
